module.exports = __webpack_public_path__ + "static/media/south-dakota.c2b9df51.jpg";